import { BaseService } from '../../infra/base.service'
import type { ManagerEntity } from './manager.entity'
import type { ManagersRepository } from './managers.repository'

export class ManagersService extends BaseService<ManagerEntity> {
    constructor(private rep: ManagersRepository) {
        super(rep)
    }
}
